ACC.freetextordersearch = {
  isHhs: $(document).find('.ph-freetextsearch__wrapper').attr('data-ishhs'),
  $checkbox: $(document).find('.ph-freetextsearch__checkbox'),
  textCopy: {
    closeDiv: '</div>',
    closeDoubleDiv: '</div></div>',
    closeSpanDiv: '</span></div>',
    pStrongOpen: '<p class="strong">',
    spanStrongOpen: '<span class="strong">',
    pDetailsOpen: '</span><p class="ph-order-delivery-details ph-mb-2">'
  },
  textSearchData: 'ph-freetextsearch__data',
  pageCount: 'ph-freetextsearch__pagecount',
  dataPages: 'data-number-of-pages',
  dataInitiated: 'data-initiated',
  resultCount: 0,
  sortingText: 'ph-sortingtext_',
  showOrHide: function(row, className) {
    if ($('.' + row).find('.' + className + ':has(mark)').length > 0) {
      $('.' + row).find('.' + className).removeClass('ph-d-none');
    } else {
      $('.' + row).find('.' + className).addClass('ph-d-none');
    }
  },
  markOrNot: function(key) {
    var row = 'context-' + key;

    ACC.freetextordersearch.showOrHide(row, 'ph-orderhistory_details');
    ACC.freetextordersearch.showOrHide(row, 'ph-orderhistory_total');
  }
};
